// extracted by mini-css-extract-plugin
module.exports = {"sticky":"jQLIq","alertHurryUp":"_1q5Al","stickyPositionScrollDown":"zVPDG","stickyPositionScrollUp":"_25O9d"};